module.exports = __webpack_public_path__ + "static/media/read_content_aloud_kannada.57b59911.mp3";